module.exports = __webpack_public_path__ + "img/d1.44b29f90.png";